import { useMutation, useQueryClient } from "@tanstack/react-query";

import { WorkRequirementType } from "@/domain/workRequirements";

import { WorkRequirementsApi } from "../api/workRequirementsApi";
import { WorkRequirementsQueryKeys } from "../queries/workRequirementsQueries";

// Every endpoint returns the refreshed work requirement, so the detail cache is
// seeded directly and only the list needs refetching.
const useSyncWorkRequirement = () => {
  const queryClient = useQueryClient();

  return async (workRequirement: WorkRequirementType | undefined) => {
    if (workRequirement) {
      queryClient.setQueryData(
        WorkRequirementsQueryKeys.details(workRequirement.id),
        workRequirement,
      );
    }
    await queryClient.invalidateQueries({
      queryKey: WorkRequirementsQueryKeys.list(),
    });
  };
};

export const useUpdateWorkRequirementScreeningMutation = () => {
  const syncWorkRequirement = useSyncWorkRequirement();

  return useMutation({
    mutationFn: WorkRequirementsApi.updateWorkRequirementScreening,
    onSuccess: syncWorkRequirement,
  });
};

export const useAddWorkRequirementDocumentMutation = () => {
  const syncWorkRequirement = useSyncWorkRequirement();

  return useMutation({
    mutationFn: WorkRequirementsApi.addWorkRequirementDocument,
    onSuccess: syncWorkRequirement,
  });
};

export const useTrackVolunteerOfframpClickMutation = () => {
  const syncWorkRequirement = useSyncWorkRequirement();

  return useMutation({
    mutationFn: WorkRequirementsApi.trackVolunteerOfframpClick,
    onSuccess: syncWorkRequirement,
  });
};
